const AbiQueryApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/query/ui/get`,
  SUBMIT: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/query/submit`,
  GET_RESPONSE: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/query/response/get`
};

export default AbiQueryApiUrls
